import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-4EGX6M5U.mjs";
import "./chunk-NNHCCRGN.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
